import { render, staticRenderFns } from "./VisaRecommendationCheck.vue?vue&type=template&id=e5f0b818&scoped=true&"
import script from "./VisaRecommendationCheck.vue?vue&type=script&lang=js&"
export * from "./VisaRecommendationCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0b818",
  null
  
)

export default component.exports